import { fetchMe } from './utils/api.js';
import { setSettingsLoaded, isSettingsLoaded } from './utils/settings-state.js';

function setSettingsLoading(isLoading) {
    const settings = document.getElementById('settings');
    const loading = document.getElementById('settings-loading');
    settings.setAttribute('aria-busy', String(isLoading));
    settings.classList.toggle('settings-loading', isLoading);
    loading?.classList.toggle('is-hidden', !isLoading);
}

function renderSettingsProfile(profile) {
    document.getElementById('settings-name').textContent =
        profile.name
        || window.user?.displayName
        || 'User Name';
    document.getElementById('settings-email').textContent =
        profile.email || window.user?.email || '';
    document.getElementById('settings-pic').src =
        window.user?.photoURL || new URL('../img/user.svg', import.meta.url).href;

    const typeEl = document.getElementById('settings-user-type');
    if (typeEl) {
        typeEl.textContent = profile.userType
            ? profile.userType.charAt(0).toUpperCase() + profile.userType.slice(1)
            : '—';
    }

    const jobEl = document.getElementById('settings-job-title');
    if (jobEl) {
        jobEl.textContent = profile.jobTitle || '—';
    }

    const appsList = document.getElementById('settings-apps-list');
    appsList.innerHTML = '';
    const apps = profile.apps || [];
    if (!apps.length) {
        appsList.innerHTML = '<li class="text-muted">No software access assigned yet.</li>';
    } else {
        apps.forEach((app) => {
            const li = document.createElement('li');
            li.innerHTML = `<strong>${app.name}</strong> — ${app.roleLabel || app.role}`;
            appsList.appendChild(li);
        });
    }
}

async function refreshSettingsFromApi() {
    const me = await fetchMe();
    const profile = me.data || {};
    window.meProfile = profile;
    renderSettingsProfile(profile);
    setSettingsLoaded(true);
    return profile;
}

export async function loadSettings(override = false) {
    if (isSettingsLoaded() && !override) {
        return;
    }

    // Paint instantly from login cache, then refresh in background.
    if (window.meProfile && !override) {
        renderSettingsProfile(window.meProfile);
        setSettingsLoaded(true);
        setSettingsLoading(false);
        refreshSettingsFromApi().catch((error) => {
            console.error('Background settings refresh failed:', error);
        });
        return;
    }

    setSettingsLoading(true);
    try {
        await refreshSettingsFromApi();
    } finally {
        setSettingsLoading(false);
    }
}
